import { messagesSlice } from './slice'

export const {
  // Messages List
  setMessagesListLoading,
  setMessagesList,
  resetMessagesList,
  setMessagesFilterText,
  filterMessageByOption,
  filterMessagesByText,
  setMessagesCount,


  // Send Messages
  setSendMessageLoading,
  setSendMessageSuccess,
  setSendMessageError,
  resetSendMessage,
  addNewMessageSended,

  // Read message
  setReadMessageLoading,
  setReadMessageSuccess,
  setReadMessageCurrentId,
  resetReadMessage

} = messagesSlice.actions
